import {Component, Input} from '@angular/core';
import {DacklFilterMultiSelectComponent, DacklFilterMultiSelectItem} from '@datev/ngx-dackl';
import {Observable} from 'rxjs';
import {FilterContext, FilterService} from '../../shared/service/filter/filter.service';
import {map} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';
import {ProductFilterElement} from '../../shared/model/filter';


@Component({
    selector: 'myupdates-filter-product',
    imports: [
        DacklFilterMultiSelectComponent,
        AsyncPipe
    ],
    templateUrl: './filter-product.component.html',
    styleUrl: './filter-product.component.scss'
})
export class FilterProductComponent {

  @Input()
  context: FilterContext = FilterContext.ProductChange;

  filterOptions$: Observable<Array<DacklFilterMultiSelectItem<ProductFilterElement>>>;

  constructor(private readonly filterService: FilterService) {

    this.filterOptions$ = this.filterService.getProductFilters(this.context).pipe(
      map(filters => filters.map(filter => ({
        label: filter.name,
        selected: filter.selected,
        payload: filter
      } as DacklFilterMultiSelectItem<ProductFilterElement>)))
    );

  }

  updateOptions(updatedOptions: Array<DacklFilterMultiSelectItem<ProductFilterElement>>): void {
    this.filterService.updateProductFilters(this.context, updatedOptions.map(option => ({
      id: option.payload?.id ?? '',
      name: option.label,
      selected: option.selected ?? false,
      associatedHknrs: option.payload?.associatedHknrs ?? []
    })));
  }

}
